<template>
  <div>
    <div
      class="c-searchCategory"
      v-if="!isSP"
    >
      <ul>
        <li
          class="c-searchCategory-item -all"
          :class="{ '-current': !categoryId }"
        >
          <button
            @click="searchCategory()"
            class="c-searchCategory-button"
            :class="{ 'current': !categoryId }"
          >
            <span
              class="arrow-left"
              v-if="categoryId"
            >
              <coconala-icon name="chevron-left" />
            </span>
            <span class="category-name">
              すべてのカテゴリ
            </span>
            <span
              class="arrow-right"
              v-if="!categoryId"
            >
              <coconala-icon name="chevron-right" />
            </span>
          </button>
        </li>
        <li
          v-if="categoryId"
          class="c-searchCategory-item -parent"
        >
          <button
            @click="searchCategory(categories[0].id)"
            class="c-searchCategory-button"
            :class="{ 'current': categories[0].isCurrent }"
          >
            <span class="category-name">
              {{ categories[0].name }}
            </span>
          </button>
        </li>
        <li
          v-for="category in setCategories()"
          :key="category.id"
          class="c-searchCategory-item"
          :class="[{ '-child': isSubcategories }, '-parent']"
        >
          <div v-if="categoryId">
            <button
              @click="searchCategory(category.id)"
              class="c-searchCategory-button"
              :class="{ 'current': category.isCurrent }"
            >
              <span class="category-name">
                {{ category.name }}
              </span>
              <span
                class="arrow-right"
                v-if="!categoryId"
              >
                <coconala-icon name="chevron-right" />
              </span>
            </button>
          </div>
          <search-category-subcategory
            v-else
            :categoryId="categoryId"
            :categories="category"
            :isLoading="isLoading"
            @change="searchCategory($event.categoryId)"
          />
        </li>
      </ul>
    </div>
    <div
      class="c-searchCategory"
      v-else
    >
      <a
        href="javascript:;"
        class="c-searchCategory_changeCondition"
        @click="$emit('click')"
        v-if="modalCategory.name"
      >変更する</a>
      <div class="c-searchCategory_button">
        <c-button
          size="medium"
          :color="modalCategory.name ? '' : 'secondary'"
          isOutlined
          isFull
          @click="$emit('click')"
        >
          {{ modalCategory.name ? modalCategory.name : 'カテゴリを選択してください' }}
        </c-button>
      </div>
    </div>
  </div>
</template>
<script>
// vuex
import { mapState, mapGetters } from 'vuex'
import SearchCategorySubcategory from './SearchCategorySubcategory'

export default {
  name: 'SearchCategory',
  components: {
    SearchCategorySubcategory
  },
  props: {
    categoryId: {
      type: [String, Number],
      default: null
    },
    categoryTitle: {
      type: String,
      default: null
    },
    modalCategory: {
      type: Object,
      default: () => {}
    },
    categories: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      attributes: {
        categoryId: this.categoryId
      },
      isSubcategories: false,
      composing: false,
      params: this.$route.query
    }
  },
  methods: {
    searchCategory(id = null) {
      this.attributes.categoryId = id
      this.$emit('change', this.attributes)
    },
    setCategories() {
      if (this.categoryId) {
        this.isSubcategories = true
        return this.categories[0].subMasterCategoriesList
      }
      return this.categories
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP'])
  }
}
</script>
<style lang="scss" scoped>
/deep/ .c-searchCategory {
  &-item {
    font-size: 13px;

    &.-child {
      padding-left: 13px;
    }

    &:hover {
      background: $color-gray-50;
    }
  }

  &-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    appearance: none;
    text-align: left;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 8px 0 8px 13px;
    line-height: 1;
    font-size: 13px;

    &.current {
      font-weight: bold;
    }

    .category-name {
      flex: 1;
    }

    .arrow-left {
      flex-basis: auto;
      align-self: center;
      font-size: 10px;
      color: $color-gray-300;
      text-align: left;
      margin-left: -12px;
      padding-right: 2px;
    }

    .arrow-right {
      flex-basis: auto;
      align-self: center;
      font-size: 10px;
      color: $color-gray-300;
      text-align: right;
      padding-right: 12px;
    }
  }

  @media (max-width: breakpoint(Requests, S)) {
    position: relative;

    .c-searchCategory_changeCondition {
      position: absolute;
      right: 0;
      top: -24px;
      font-size: 13px;
    }
  }
}
</style>
